import { Link } from 'react-router-dom';

import Layout from '../../components/Layout.js';
import { PaperData } from './data';

import './Paper.css'

import ieee from '../../assets/logos/ieee.png';
import arxiv from '../../assets/logos/arxiv.png';


function Papers() {

    function makePaper(key, image, title, authors, link, located_text, location, slug) {
        const isPublished = location !== "";

        return (
            <div className={`Paper${!isPublished ? ' Paper--in-progress' : ''}`} key={key}>
                <img
                    className='PaperImg'
                    alt='paper preview'
                    src={require('../../assets/paper_images/' + image)}
                />

                <div className='PaperInfo'>
                    <h3>{title}</h3>

                    <h4>
                        <span className='author'>Authors</span>&nbsp;
                        {authors.map((name, idx) => (
                            <span
                                key={`${key}_${idx}`}
                                style={{ fontWeight: name.includes('Reidy') ? '700' : '400' }}
                            >
                                {idx ? ', ' : ''}{name}
                            </span>
                        ))}
                    </h4>

                    <div className='paperBtnContainer'>
                        {/* <Link className='learnMoreBtn' to={`/papers/${slug}`}>
                            Learn More
                        </Link> */}

                        {location === "arxiv" && (
                            <a className='learnMoreBtn' href={link} target="_blank" rel="noopener noreferrer">
                                Read at <img src={arxiv} alt='arxiv' style={{ height: '11px' }} />
                            </a>
                        )}

                        {location === "ieee" && (
                            <a className='learnMoreBtn' href={link} target="_blank" rel="noopener noreferrer">
                                Read at <img src={ieee} alt='ieee' style={{ height: '11px' }} />
                            </a>
                        )}

                        {location === "" && (
                            <span className='inProgress'>In Progress</span>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    const data = PaperData.map((p, idx) =>
        makePaper(idx, p.image, p.title, p.authors, p.link, p.appearsIn, p.location, p.slug)
    );

    return (
        <Layout pageIndex={4}>

            <div className="papers-hero page-hero noise">
                <div className="papers-header">
                    <p className="section-eyebrow">What I've published</p>
                    <h1 className="papers-page-title">Publications</h1>
                    <p className="papers-page-sub">{PaperData.length} papers across AI-generated content detection and computational social choice.</p>
                </div>
            </div>

            <div className='main-content-container'>

            {/* ── Deep Learning Section ── */}
            <div className='paperSectionContainer'>
                <div className='paperSubsection'>
                    <h2 className="section-title">Deep-Learning Research</h2>
                    <p>
                        My primary academic research focuses on identifying <strong>AI-generated content (AIGC) detection</strong>. To realize this, I have:
                    </p>
                    <ul>
                        <li>
                            Developed novel techniques to identify AIGC images by detecting the camera-based artifacts that are typically present in genuine photos.
                        </li>
                        <li>
                            Published and presented this work at the <strong>2023 IEEE International Conference on Big Data</strong>.
                        </li>
                        <li>
                            Built practical tools such as a <strong>social media bot detector</strong> that uses a fine-tuned transformer encoder to evaluate how likely a piece of text was produced by a bot.
                        </li>
                    </ul>
                </div>

                <div className='paperGrid noise'>
                    {data.slice(0, 4)}
                </div>
            </div>

            <hr/>

            {/* ── COMSOC Section ── */}
            <div className='paperSectionContainer'>
                <div className='paperSubsection'>
                    <h2 className="section-title">COMSOC Research</h2>
                    <p>
                        I also specialize in <strong>computational social choice (COMSOC)</strong>, with a focus on the complexity of manipulating election systems. My work includes:
                    </p>
                    <ul>
                        <li>
                            Analyzing control strategies such as <em>adding, deleting, or partitioning</em> candidates or voters to determine their impact on election outcomes.
                        </li>
                        <li>
                            Studying whether it's <strong>computationally feasible</strong> for a chair to rig an election by designing polynomial-time algorithms for manipulation and proving NP-completeness to show resistance to control.
                        </li>
                        <li>
                            Publishing critical evaluations of proposed solutions to the <strong>P vs. NP</strong> problem that assess the validity of proposed proofs and formally refute flawed arguments.
                        </li>
                    </ul>
                </div>

                <div className='paperGrid noise'>
                    {data.slice(4)}
                </div>
            </div>

            </div>


        </Layout>
    );
}

export default Papers;